import styled from 'styled-components'
import { getFontStyle } from '@diversioteam/diversio-ds'

// Card styled-components that exactly match Tailwind CSS output
// Using the same CSS custom properties as defined in globals.css

export const StyledCard = styled.div`
    /* bg-card text-card-foreground flex flex-col rounded-xl border */
    background-color: var(--card); /* bg-card - using CSS variable */
    color: var(--card-foreground); /* text-card-foreground - using CSS variable */
    display: flex; /* flex */
    flex-direction: column; /* flex-col */
    border-radius: 12px; /* rounded-xl */
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); /* shadow-card from globals.css */

    /* Enhanced mobile shadows */
    @media (max-width: 768px) {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
`

export const StyledCardHeader = styled.div`
    /* @container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6 */
    container-type: inline-size; /* @container/card-header */
    container-name: card-header;
    display: grid; /* grid */
    grid-auto-rows: min-content; /* auto-rows-min */
    grid-template-rows: auto auto; /* grid-rows-[auto_auto] */
    align-items: start; /* items-start */
    gap: 6px; /* gap-1.5 */
    padding-left: 24px; /* px-6 */
    padding-right: 24px;
    padding-top: 24px; /* pt-6 */
    margin-bottom: 20px; /* Larger gap between header and body */

    /* has-data-[slot=card-action]:grid-cols-[1fr_auto] */
    &:has([data-slot='card-action']) {
        grid-template-columns: 1fr auto;
    }

    /* [.border-b]:pb-6 - when parent has border-b class */
    .border-b & {
        padding-bottom: 24px; /* pb-6 */
    }
`

export const StyledCardTitle = styled.h4`
    /* leading-none */
    ${getFontStyle('subheaderSemibold')} /* 14px, 600 weight - much lighter card headers */
    line-height: 1; /* leading-none */
`

export const StyledCardDescription = styled.p`
    /* text-muted-foreground */
    ${getFontStyle('p02Regular')} /* 14px, 400 weight - standard description text */
    color: var(--muted-foreground); /* text-muted-foreground - using CSS variable */
`

export const StyledCardAction = styled.div`
    /* col-start-2 row-span-2 row-start-1 self-start justify-self-end */
    grid-column-start: 2; /* col-start-2 */
    grid-row: span 2 / span 2; /* row-span-2 */
    grid-row-start: 1; /* row-start-1 */
    align-self: start; /* self-start */
    justify-self: end; /* justify-self-end */
`

export const StyledCardContent = styled.div`
    /* px-6 [&:last-child]:pb-6 */
    padding-left: 24px; /* px-6 */
    padding-right: 24px;
    margin-bottom: 16px; /* Smaller gap between body and footer */

    /* [&:last-child]:pb-6 */
    &:last-child {
        padding-bottom: 24px; /* pb-6 */
        margin-bottom: 0; /* Remove margin if it's the last child */
    }
`

export const StyledCardFooter = styled.div`
    /* flex items-center px-6 pb-6 [.border-t]:pt-6 */
    display: flex; /* flex */
    align-items: center; /* items-center */
    padding-left: 24px; /* px-6 */
    padding-right: 24px;
    padding-bottom: 24px; /* pb-6 */

    /* [.border-t]:pt-6 - when parent has border-t class */
    .border-t & {
        padding-top: 24px; /* pt-6 */
    }
`
